import { render, staticRenderFns } from "./addsubRecordDialog.vue?vue&type=template&id=259907df&scoped=true&"
import script from "./addsubRecordDialog.vue?vue&type=script&lang=js&"
export * from "./addsubRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259907df",
  null
  
)

export default component.exports